import { render, staticRenderFns } from "./ItemAdder.vue?vue&type=template&id=f9bb6926"
import script from "./ItemAdder.vue?vue&type=script&lang=js"
export * from "./ItemAdder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports